<template>
  <va-page-not-found class="va-page-not-found-large-text" :title="$t('error.page403.title')" :description="$t('error.page403.description')">
    <div class="va-page-not-found-large-text__number" slot="image">403</div>
  </va-page-not-found>
</template>

<script>
import VaPageNotFound from './VaPageNotFound'

export default {
  name: 'va-page-not-found-large-text',
  components: {
    VaPageNotFound,
  },
}
</script>

<style lang="scss" scoped>
.va-page-not-found-large-text {
  &__number {
    font-size: 21rem;
    color: $white;
    font-weight: 600;
    @include media-breakpoint-down(xs) {
      font-size: 12rem;
    }
  }
}
.va-page-not-found {
  &__wallpaper {
    background-image: url("../../../assets/images/vsef.jpg") !important;
  }
}
</style>
